import {useCallback} from 'react'
import {useHistory, useLocation} from 'react-router-dom'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {HOME_HREF} from '@salesforce/retail-react-app/app/constants'

const useHomeNavigation = ({onNavigate} = {}) => {
    const history = useHistory()
    const {pathname} = useLocation()
    const {buildUrl} = useMultiSite()

    const homePath = buildUrl(HOME_HREF)
    const isOnHome = pathname === homePath || pathname === HOME_HREF

    const navigateHome = useCallback(
        (event) => {
            if (
                event &&
                (event.metaKey ||
                    event.ctrlKey ||
                    event.shiftKey ||
                    event.altKey ||
                    (typeof event.button === 'number' && event.button !== 0))
            ) {
                return
            }
            event?.preventDefault?.()
            onNavigate?.()
            if (isOnHome) {
                window.scrollTo({top: 0, behavior: 'smooth'})
                return
            }
            history.push(homePath)
        },
        [history, homePath, isOnHome, onNavigate]
    )

    return {navigateHome}
}

export default useHomeNavigation
